import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../../../features/userSlice";
import { fetchServiceRequests } from "../../WindowDoor/ServiceRequests/api";
import { isOpen } from "../../WindowDoor/ServiceRequests/constants";
import WidgetFrame, { WidgetEmpty, WidgetStat } from "./WidgetFrame";

// A salesperson's own service requests: how many are still moving, how many
// are waiting on a technician, how many finished.
const MyServiceRequestsWidget = () => {
  const user = useSelector(selectUser);
  const [requests, setRequests] = useState(null);

  useEffect(() => {
    if (!user?.email && !user?.userID) return;
    fetchServiceRequests({ scope: "mine", status: "all", user })
      .then((data) => setRequests(Array.isArray(data) ? data : []))
      .catch(() => setRequests([]));
  }, [user?.email, user?.userID]);

  if (!requests) {
    return (
      <WidgetFrame
        title="My Service Requests"
        to="/windowdoor/my-service-requests"
      >
        <WidgetEmpty>Loading your requests…</WidgetEmpty>
      </WidgetFrame>
    );
  }

  const open = requests.filter((row) => isOpen(row.status));
  const unassigned = open.filter((row) => !row.assigned_to?.userID);
  const completed = requests.filter(
    (row) => row.status === "Service Completed"
  );

  return (
    <WidgetFrame
      title="My Service Requests"
      to="/windowdoor/my-service-requests"
    >
      <div className="grid grid-cols-3 gap-2">
        <WidgetStat value={open.length} label="Open" />
        <WidgetStat value={unassigned.length} label="Awaiting tech" />
        <WidgetStat value={completed.length} label="Completed" />
      </div>
    </WidgetFrame>
  );
};

export default MyServiceRequestsWidget;
